import React, { useEffect, useState } from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';

import ResetPswSuccessPage from './scenes/resetpsw/ResetPswSuccessPage';
import AppMainComponent from './AppMainComponent';
import { MuiThemeProvider } from '@material-ui/core';
import {
  getBrandByPath,
  getLogoByPath,
  getLogoLeftByPath,
} from './utils/api/brand_api';
import './App.css';
import Footer from './components/Footer';
import Favicon from 'react-favicon';
import logo from '../src/logo.png';
import { MicroFrontendProvider } from './utils/MicroFrontendContext';
import ErrorDialog from './components/ErrorDialog';
import AppErrorDialog from './components/AppErrorDialog';
import HostSessionExpiredDialog from './components/HostSessionExpiredDialog';
import { getMicrosoftErrorMessage } from './auth/microsoftAuth.errors';
import { createAppTheme } from './createAppTheme';

export default function App({ microsoftAuthError }) {
  const [showMicrosoftError, setShowMicrosoftError] =
    useState(!!microsoftAuthError);
  const [theme, setTheme] = useState();
  const [loading, setLoading] = useState(false);
  const [is404, setIs404] = useState(false);

  useEffect(() => {
    setShowMicrosoftError(!!microsoftAuthError);
  }, [microsoftAuthError]);

  const closeMicrosoftError = () => setShowMicrosoftError(false);

  useEffect(() => {
    setLoading(true);
    let url = window.location.pathname.split('/')[1];
    const currentPath = url === '' ? 'bsfood' : url;

    getBrandByPath(currentPath)
      .then((response) => {
        Promise.all([
          getLogoByPath(currentPath),
          getLogoLeftByPath(currentPath),
        ])
          .then(([logoResponse, logoLeftResponse]) => {
            setTheme({
              primaryColor: response.primaryColor,
              secondaryColor: response.secondaryColor,
              textColor: response.textColor,
              logo: logoResponse,
              logoLeft: logoLeftResponse,
              nomeBrand: response.nome,
              path: response.path || currentPath,
            });

            document.title =
              url !== ''
                ? `${response.nome} Control Panel`
                : 'BS-FOOD Control Panel';

            setLoading(false);
            setIs404(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      })
      .catch((error) => {
        if (error.status === 404) {
          console.log(error);
          setIs404(true);
        } else {
          console.error(error);
        }

        setLoading(false);
      });
  }, []);

  const muiTheme = createAppTheme(theme);

  if (!theme) {
    // Puoi decidere come gestire il caso in cui i dati del tema non siano ancora disponibili
    //return null; // o un componente di caricamento, un messaggio, ecc.
  }

  return loading ? (
    <div className="loadingBrand">
      <div className="spinnerBrand"></div>
      <p>Caricamento...</p>
    </div>
  ) : (
    <MicroFrontendProvider>
      <MuiThemeProvider theme={muiTheme}>
        <Favicon url={muiTheme.logoLeft.url || logo} />
        <BrowserRouter>
          <HostSessionExpiredDialog />
          <AppErrorDialog />
          <div className="App">
            <div className="AppMainOutlet">
              <Switch>
                <Route
                  path="/reset_password_success"
                  component={ResetPswSuccessPage}
                />
                <Route
                  path="/"
                  render={() => <AppMainComponent is404={is404} />}
                />
              </Switch>
            </div>
            {!is404 && <Footer />}
          </div>
          <ErrorDialog
            open={showMicrosoftError}
            title="Problema con l'accesso Microsoft"
            message={getMicrosoftErrorMessage(
              microsoftAuthError?.reason,
              microsoftAuthError?.message,
            )}
            onCloseButtonClicked={closeMicrosoftError}
          />
        </BrowserRouter>
      </MuiThemeProvider>
    </MicroFrontendProvider>
  );
}
